import React, { FC, useState, useEffect } from 'react'
import { Button, Table, Input, Row, Col, Form } from 'antd'
import { YhBox } from '@/components/YhBox'
import { ColumnsType } from 'antd/es/table'
import { RouterParamType } from '@/model/navModel'
import YhDebounceSelect from '@/components/YhDounceSelect'
import { supplierService } from '../../supplierService'
import { ISupplierPurchaseHistoryDetail, ISupplierPurchaseHistorySearchFields } from '../../supplierTypes'
import { ISearchPage, IPgProps } from '@/types/ScmTypes'
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from '@/utils/constants'
import { TablePaginationConfig } from 'antd/lib/table'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { useSupplierDetailsMode } from './supplierDetailsModel'
import { inquiryService } from '@/views/inquiry/inquiryService'

export const PurchaseHistory: FC<RouterParamType> = ({ id, mode }) => {
    const { editFormVal } = useSupplierDetailsMode()
    const { setLoadingInfo, fetchSupplierList } = useGlobalModel()
    // 查询条件
    const [searchParam, setSearchParam] = useState<ISupplierPurchaseHistorySearchFields>({})

    // 数据源
    const [dataSource, setDataSource] = useState<ISupplierPurchaseHistoryDetail[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    // 分页配置
    const initPgCfg: TablePaginationConfig = {
        pageSize: DEFAULT_PAGE_SIZE,
        current: DEFAULT_FIRST_PAGE_NUM,
    }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)

    useEffect(() => {
        if (editFormVal.code) {
            loadData()
        }
    }, [editFormVal.code, searchParam])

    // 表格列定义
    const columns: ColumnsType<ISupplierPurchaseHistoryDetail> = [
        {
            title: '序号',
            width: 60,
            fixed: 'left',
            align: 'center',
            render: (t: any, r: any, i: number) => (pgCfg.current! - 1) * pgCfg.pageSize! + i + 1,
        },
        {
            title: '采购单号',
            width: 140,
            dataIndex: 'purchaseCode',
        },
        {
            title: '所属系统',
            width: 140,
            dataIndex: 'sourceApp',
        },
        {
            title: '所属门店',
            width: 140,
            dataIndex: 'shopName',
        },
        {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
        },
        {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
        },
        {
            title: '单价',
            width: 100,
            dataIndex: 'price',
            render: (value: number) => value?.toFixed(2),
        },
        {
            title: '供应商编码',
            width: 120,
            dataIndex: 'supplierCode',
        },
        {
            title: '供应商名称',
            width: 160,
            dataIndex: 'supplierName',
        },
    ]

    // 加载数据
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: ISupplierPurchaseHistorySearchFields = searchParam) => {
        setLoading(true)
        try {
            const searchParams = {
                ...searchValue,
                supplierCode: editFormVal.code,
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }

            const { retData } = await supplierService.purchaseHistory(searchParams)
            const { records, ...pg } = retData
            setPgCfg(transPgToPagination(pg))
            setDataSource(records || [])
        } catch (error) {
            console.error('加载采购历史数据失败:', error)
            setDataSource([])
        } finally {
            setLoading(false)
        }
    }

    return (
        <YhBox style={{ padding: '20px' }}>
            {/* 查询条件 */}
                <Row gutter={10}>
                    <Col span={6}>
                     <Input
                        style={{  flex: 1, marginRight: '10px' }}
                        placeholder="配件编码"
                        value={searchParam.materialCode}
                        onChange={(e) => {
                            setSearchParam({
                                ...searchParam,
                                materialCode: e.target.value,
                            })
                        }}
                    />
                    </Col>
                    <Col span={6}>
                    <Input
                        style={{ flex: 1, marginRight: '10px' }}
                        placeholder="配件名称"
                    value={searchParam.materialName}
                    onChange={(e) => {
                        setSearchParam({
                            ...searchParam,
                            materialName: e.target.value,
                        })
                    }}
                    />
                    </Col>
                   </Row>

            {/* 数据表格 */}
            <Table
                rowKey={(record) => record.id}
                loading={loading}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ['bottomCenter'],
                    showTotal: (total) => `共${total}条`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                }}
                scroll={{ x: 'max-content', y: '400px' }}
            />
        </YhBox>
    )
}
